/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import router from '@/router';
import moment from 'moment';
import { ADD_TOAST_MESSAGE } from '@/plugins/vuex-toastr/module';
import vuetify from '@/plugins/vuetify';
import auth from '@/services/auth';
import realtime from '@/services/realtime';

import UserCollection from '@/classes/UserCollection';
import UserEx from '@/classes/UserExCollection';
import UserInfoApi from '@/classes/user-info';

// initial state
const state = {
  user: {},
};

// getters
const getters = {
  isAdmin: function (state) {
    return !!(state.user.roles || []).filter(({ name }) => name === 'ADMIN' || name === '_ALL')
      .length;
  },
  isTeacher: function (state, getters) {
    return (
      getters.isAdmin || !!(state.user.roles || []).filter(({ name }) => name === '_TEACHER').length
    );
  },
  userLang: function (state) {
    const { language } = state.user;
    return language ? language.toLowerCase() : false;
  },
};

// actions
const actions = {
  ...UserInfoApi.actions,
  ...UserEx.actions,
  userLogin: UserCollection.actions.login,

  async logIn({ dispatch }, payload) {
    let params;

    if (typeof payload === 'string') {
      params = { token: payload };
    } else {
      params = payload;
    }

    const userInfo = await dispatch('LogInByJwt', params);
    return userInfo;
  },

  async logout() {
    await auth.logout(Vue, '/builtinchat');
  },

  // logout(props, redirect) {
  //   window.$socket.emit('logout', localStorage.getItem('$LoopBack$accessTokenId'));
  //   sessionStorage.setItem('return_to', window.location.href);
  //   // window.location = `${ window.location.protocol }//${ window.location.host }/login/#/logout`;
  //   router.push('/login');
  // },

  async fetchMyself({ commit, dispatch, rootGetters }) {
    if (!window.$socket) return console.log('fetchMyself: no socket connect');
    window.$socket.emit('/fetchMyself/User', me => {
      if (!me.error) {
        let language = 'language' in me ? me.language : null;
        commit('language/setUserLanguage', language, { root: true });

        commit('setUser', me);
        dispatch('notifications/initPushService', { userId: me.id }, { root: true });
      } else {
        let text = Vue.i18n.translate('Something went wrong. Please try again later');
        if (me.error) {
          text = me.error;
        }
        console.log('user (line : 51) | actions:fetchMyself | ADD_TOAST_MESSAGE text: ', text);
        dispatch(ADD_TOAST_MESSAGE, { type: 'error', text }, { root: true });
        dispatch('logout');
      }
    });
  },
};

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
